import { defineStore } from "pinia";

export const useSettingsStore = defineStore("settings", {
  state: () => ({
    formUpdateThresholdDays: 180, // Default threshold in days
  }),
  actions: {
    setFormUpdateThresholdDays(days) {
      this.formUpdateThresholdDays = days;
    },
  },
});
